import { Logic } from "../types/logic";

export const getSafeWelcomeScreen = (data: any) => {
    if (!data) return null;
    if (Array.isArray(data) && data.length === 0) return null;
    if (Array.isArray(data) && data.length > 0) data = data[0];

    return {
        id: data?.id,
        type: "welcome_screen",
        title: data?.title,
    };
};

export const getSafeFields = (data: any) => {
    const welcomeScreen = getSafeWelcomeScreen(data?.welcome_screens);
    const endScreen = getSafeEndScreen(data?.thankyou_screens);
    const fields = data?.fields?.map((field: any) => getSafeField(field));

    if (!welcomeScreen && !endScreen) return fields;
    if (!welcomeScreen) return [...fields, endScreen];
    if (!endScreen) return [welcomeScreen, ...fields];
    return [welcomeScreen, ...fields, endScreen];
};

export const getSafeField = (data: any) => {
    if (data?.type === "multiple_choice")
        return {
            id: data?.id,
            type: data?.type,
            title: data?.title,
            choices: data?.properties?.choices,
        };

    return {
        id: data?.id,
        type: data?.type,
        title: data?.title,
    };
};

export const getSafeEndScreen = (data: any) => {
    if (!data) return null;
    if (Array.isArray(data) && data.length === 0) return null;
    if (Array.isArray(data) && data.length > 0) data = data[0];

    return {
        id: data?.id,
        type: "end_screen",
        title: data?.title,
    };
};

export const getSafeLogics = (data: any) => {
    if (!Array.isArray(data)) return [];
    return data?.map((logic: any) => getSafeLogic(logic)) as any[];
};

export const getSafeLogic = (data: any): Logic => {
    return {
        fieldId: data.field_id,
        defaultTargetId: data.default_target_field_id,
        branches: data.branches.map((branch: any) => ({
            id: branch.branch_id,
            name: branch.branch_name,
            targetId: branch.target_field_id,
            groups: branch.logic_groups.map((group: any) => ({
                id: group.group_id,
                name: group.group_name,
                rules: group.rules.map((rule: any) => ({
                    id: rule.rule_id,
                    sourceId: rule.source_field_id,
                    operator: rule.operator,
                    expectedValue: rule.operand,
                })),
            })),
        })),
    };
};
